import { GetStaticPaths, GetStaticProps, GetStaticPropsContext } from 'next'

import initApollo, { API } from '../../api'

import { PAGES, COLLECTION } from './queries'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.SeriesPages>({
    query: PAGES,
  })

  const series = data.libraryCollections?.nodes

  const paths = series?.map((serie) => `/series/${serie.slug}`) ?? []

  return { paths, fallback: false }
}

const recurse = (a: any) =>
  a.reduce(
    (acc: any, v: { content: any; value: any }) =>
      `${acc}${v.content ? recurse(v.content) : v.value}`,
    '',
  )

export type Props = NonNullable<API.Collection['libraryCollection']>

export const getStaticProps = async ({ params }: GetStaticPropsContext) => {
  const client = initApollo({})

  const { data } = await client.query<API.Collection, API.CollectionVariables>({
    query: COLLECTION,
    variables: {
      slug: params!.slug as string,
    },
  })

  return {
    props: {
      ...data.libraryCollection,
      seoDescription: recurse(JSON.parse(`${data.libraryCollection?.description}`).content),
    },
  }
}
